<ng-container *ngIf="relatedData">
    <div class="container-sample-view d-flex flex-column align-items-center justify-content-center w-100"
        [ngClass]="{'bg-neutral-95': oggetto_view !== 'pagine' && oggetto_view !== 'persone' && oggetto_view !== 'docenti' && oggetto_view !== 'faq-procedure'}">
        <!-- TITOLI -->
        <div *ngIf="oggetto_view !== 'pagine'" class="container-title container d-flex justify-content-between align-items-center w-100">
            <div class="container-title__title">
                <h2 class="ls-h2-section-title text-brand-10" [innerHTML]="titleSection | translate"></h2>
            </div>
            <div class="container-title__button">
                <!-- <a *ngIf="!isLinkEsternal && blocks.link" [routerLink]="[blocks.link.url]">
                    <button class="btn-header-news ls-label-small-semibold text-uppercase" [innerHTML]="blocks.label_link"></button>
                </a>
                <a *ngIf="isLinkEsternal" target="_blank" [href]="[blocks.link.url]">
                    <button class="btn-header-news ls-label-small-semibold text-uppercase" [innerHTML]="blocks.label_link"></button>
                </a> -->
            </div>
        </div>
        <!-- END TITOLI -->
        <!-- PER VISTE CORRELATI -->
        <div class="container-sample-view__content-category container" *ngIf="oggetto_view !== 'persone' && oggetto_view !== 'pagine'">
            <owl-carousel-o [options]="customOptionsOwl" class="position-relative"
                [id]="'sample-view-carousel-' + oggetto_view">
                <ng-container *ngFor="let item of relatedData; let idx = index">
                    <ng-template carouselSlide let-owlItem>
                        <ng-container [ngSwitch]="oggetto_view">
                            <app-sample-news-small *ngSwitchCase="'news'" [isNews]="true" [dataNews]="item"></app-sample-news-small>
                            <app-sample-events-small *ngSwitchCase="'eventi'" [isEvent]="true" [block]="item"></app-sample-events-small>
                            <app-sample-card-avvisi *ngSwitchCase="'avvisi'" [isAvvisi]="true" [block]="item"></app-sample-card-avvisi>
                            <app-sample-card-faq *ngSwitchCase="'faq-procedure'" [isAvvisi]="true" [block]="item"></app-sample-card-faq>
                            <app-sample-card-docenti *ngSwitchCase="'docenti'" [isEvent]="true" [block]="item"></app-sample-card-docenti>
                        </ng-container>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
        <!-- END PER VISTE CORRELATI -->
    </div>
</ng-container>